import OptionConst from "@/const/Option";
import { MyTaskService } from "@/service/MyTaskService";
import { ZangyouCheckListReq, ZangyouCheckListRes } from "@/types/MyTask";
import { computed, ref, Ref } from "vue"
import { useForm } from '@/composable/form/form';
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
/*
 * 残業45時間以上のスタッフをを取得
 */
export function useList() {
  let checking = ref(0);
  let isListError = ref(false);

  let checkListInfo = ref<ZangyouCheckListRes>({
    zangyouList: [],
    start: '',
    end: ''
  });

  const { removeAllError } = useForm()

  // 読み込み中か判断する
  const isListChecking = computed(() => {
    return !(checking.value === 0 || isListError.value);
  });

  // 残業45時間以上のスタッフ一覧取得
  const getList = async (params: ZangyouCheckListReq) => {
    checking.value++;

    // API
    const srv = new MyTaskService();
    const res = await srv.getOver45Zangyou(params);

    if (res) {
      checkListInfo.value = res;
    } else {
      checkListInfo.value.zangyouList = [];
    }

    checking.value--;
  };

  return {
    isListChecking,
    isListError,
    getList,
    checkListInfo,
  };
}
